import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { TDevice } from '@cian/utils';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { favoritesContext } from '../../utils/favorites';
import { ApplicationContext } from '../ApplicationContext';
import { PageContainer } from '../Page';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
  initialDeviceType?: TDevice;
}

export class Application extends React.Component<IApplicationProps> {
  public render() {
    const {
      context,
      reduxStore,
      initialDeviceType = context.config.get<TDevice>('initialDeviceType') as TDevice,
    } = this.props;

    return (
      <ApplicationContext.Provider value={context}>
        <ErrorLogComponent logger={context.logger}>
          <Provider store={reduxStore}>
            <favoritesContext.Provider value={reduxStore}>
              <UiKitContextProvider deviceType={initialDeviceType}>
                <PageContainer />
              </UiKitContextProvider>
            </favoritesContext.Provider>
          </Provider>
        </ErrorLogComponent>
      </ApplicationContext.Provider>
    );
  }
}
